import React, { Fragment, useEffect, useState, useContext } from 'react'
import DateTimePicker from 'react-datetime-picker';
import { Link } from 'react-router-dom'
import styled, {css} from 'styled-components';

export function DatePicker(props) {
  const [value, onChange] = useState(new Date());
  return (
    <div>
<DateTimePicker
        onChange={onChange}
        value={value}
      />
    </div>
  )
}
